// extracted by mini-css-extract-plugin
export default {"surveyFlex":"CollectorSurveyModal_surveyFlex__jbMGO"};